import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { CssBaseline } from '@mui/material';
import { ThemeProvider as MUIThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
import componentsOverride from './overrides';
import getTypographyConfig from './typography';
import GlobalStyles from './globalStyles';
import customShadows from './customShadows';
import shadows from './shadows';
import { createPalette } from './palette';
import { useThemeSettings } from 'src/context/themeSettingsContext';

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

export default function ThemeProvider({ children }) {
  const { resolvedColors, resolvedTypography } = useThemeSettings();
  const palette = useMemo(() => createPalette(resolvedColors), [resolvedColors]);
  const typography = useMemo(() => getTypographyConfig(resolvedTypography), [resolvedTypography]);

  const themeOptions = useMemo(
    () => ({
      palette,
      shape: { borderRadius: 6 },
      typography,
      shadows: shadows(palette),
      customShadows: customShadows(palette),
    }),
    [palette, typography]
  );

  const theme = useMemo(() => {
    const baseTheme = createTheme(themeOptions);
    baseTheme.components = componentsOverride(baseTheme);
    return baseTheme;
  }, [themeOptions]);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
